import http from './http'

//api/User/login

let baseUrl = http.path;

export { baseUrl } ;

export function getApiBanner(data){
    return http.post('api/Index/getBannerList',data);
}

///api/Common/upload

export function getApiUpload(data){
    return http.formData('api/Common/upload',data);
}

///api/User/mobilelogin

export function getApiMobileLogin(data){
    return http.post('api/User/mobilelogin',data);
}


///api/User/login

export function getApiLogin(data){
    return http.post('api/User/login',data);
}

///api/User/register

export function getApiRegister(data){
    return http.post('api/User/register',data);
}

///api/User/resetpwd

export function getApiResetpwd(data){
    return http.post('api/User/resetpwd',data);
}

///api/Sms/send

export function getApiSend(data){
    return http.post('api/Sms/send',data);
}

///api/Index/getServicetypelist

export function getApiServiceType(data){
    return http.post('api/Index/getServicetypelist',data);
}

///api/Index/getServicelist

export function getApiServiceList(data){
    return http.post('api/Index/getServicelist',data);
}

///api/Mechanism/getMsList

export function getApiMsList(data){
    return http.post('api/Mechanism/getMsList',data);
}

///api/Mechanism/getHomeMsList

export function getApiHomeMsList(data){
    return http.post('api/Mechanism/getHomeMsList',data);
}

///api/Index/getHomeService

export function getApiHomeService(data){
    return http.post('api/Index/getHomeService',data);
}

///api/User/getUserInfos

export function getApiUserInfos(data){
    return http.post('api/User/getUserInfos',data);
}

///api/Index/getLogoList

export function getApiLogoList(data){
    return http.post('api/Index/getLogoList',data);
}

///api/Index/getHome

export function getApiHome(data){
    return http.post('api/Index/getHome',data);
}


///api/Index/setSignInfo

export function getApiSetSignInfo(data){
    return http.post('api/Index/setSignInfo',data);
}

///api/Index/getActivityForm

export function getApiActivityForm(data){
    return http.post('api/Index/getActivityForm',data);
}

///api/Index/getCoursetype

export function getApiCoursetype(data){
    return http.get('api/Index/getCoursetype',data);
}

///api/Index/getHomeCourse

export function getApiHomeCourse(data){
    return http.get('api/Index/getHomeCourse',data);
}

///api/Index/getCarrier

export function getApigetCarrier(data){
    return http.get('api/Index/getCarrier',data);
}

///api/Index/getswitchCusList

export function getApiswitchCusList(data){
    return http.get('api/Index/getswitchCusList',data);
}

///api/Index/getCategoryList

export function getApiCategoryList(data){
    return http.get('api/Index/getCategoryList',data);
}

///api/Index/getCuslocationList

export function getApigetCuslocationList(data){
    return http.post('api/Index/getCuslocationList',data);
}

///api/Index/getCuslocationInfo

export function getApigetCuslocationInfo(data){
    return http.get('api/Index/getCuslocationInfo',data);
}

///api/Index/getSwitchActivity

export function getApiSwitchActivity(data){
    return http.get('api/Index/getSwitchActivity',data);
}

////api/Index/getActivityList

export function getApiActivityList(data){
    return http.get('api/Index/getActivityList',data);
}

///api/Index/getActivityInfo

export function getApiActivityInfo(data){
    return http.get('api/Index/getActivityInfo',data);
}


export function getApiHomeData(data){
    return http.post('api/Index/getHomeData',data);
}

///api/Index/getHomeNews

export function getApiHomeNews(data){
    return http.post('api/Index/getHomeNews',data);
}


///api/Index/getNewsList


export function getApiNews(data){
    return http.post('api/Index/getNewsList',data);
}

///api/Index/getNewsInfo

export function getApiNewsinfo(data){
    return http.post('api/Index/getNewsInfo',data);
}


///api/Index/getAllDataType

export function getApiAllDataType(data){
    return http.post('api/Index/getAllDataType',data);
}

///api/Index/getAllData

export function getApiAllDataValue(data){
    return http.post('api/Index/getAllData',data);
}


export function getApiGeoCodeAddress(data){
    return http.formData('https://restapi.amap.com/v3/geocode/geo',data);
}

///api/Index/getLinkList

export function getApiLinkList(data){
    return http.post('api/Index/getLinkList',data);
}

///api/Index/getHomeIndustry


export function getApiHomeIndustry(data){
    return http.post('api/Index/getHomeIndustry',data);
}

///api/Index/getIndustryList


export function getApiIndustryList(data){
    return http.post('api/Index/getIndustryList',data);
}

///api/Index/getPolicyList

export function getApiPolicyList(data){
    return http.post('api/Index/getPolicyList',data);
}

///api/Index/getSecurityList

export function getApiSecurityList(data){
    return http.post('api/Index/getSecurityList',data);
}

///api/Index/getIndustryInfo


export function getApiIndustryInfo(data){
    return http.post('api/Index/getIndustryInfo',data);
}

///api/Index/getPolicyInfo
export function getApiPolicyInfo(data){
    return http.post('api/Index/getPolicyInfo',data);
}

///api/Index/getSecuityInfo

export function getApiSecuityInfo(data){
    return http.post('api/Index/getSecuityInfo',data);
}

///api/Members/getMembersList

export function getApiMembersList(data){
    return http.post('api/Member/getMembersList',data);
}

///api/Member/getMembersVoiceList

export function getApiMembersVoiceList(data){
    return http.post('api/Member/getMembersVoiceList',data);
}

///api/Member/getCaptcha

///api/Member/setAddVoice

export function getApisetAddVoice(data){
    return http.post('api/Member/setAddVoice',data);
}

///api/Member/getMembersVideoList

export function getApiMembersVideoList(data){
    return http.post('api/Member/getMembersVideoList',data);
}

///api/Index/getServicetype

export function getApiServicetype(data){
    return http.post('api/Index/getServicetype',data);
}

///api/Index/getZsType

export function getApiZsType(data){
    return http.get('api/Index/getZsType',data);
}

///api/Index/getHomeZsList

export function getApiHomeZsList(data){
    return http.get('api/Index/getHomeZsList',data);
}

///api/Index/getExpertsList

export function getApiExpertsList(data){
    return http.get('api/Index/getExpertsList',data);
}

///api/Index/getExpertsInfo

export function getApiExpertsInfo(data){
    return http.get('api/Index/getExpertsInfo',data);
}

///api/Policy/getPDetail

///api/Policy/getNewsListByProjectIds

export function getApiNewsListByProjectIds(data){
    return http.get('api/Policy/getNewsListByProjectIds',data);
}

///api/Policy/getCompanyName

export function getApiCompanyName(data){
    return http.post('api/Policy/getCompanyName',data);
}

///api/Policy/fastEval

export function getApiFastEval(data){
    return http.post('api/Policy/fastEval',data);
}

///api/Policy/getDetailData

export function getApigetDetailData(data){
    return http.post('api/Policy/getDetailData',data);
}

///api/Policy/assessmentdata

export function getApiassessmentdata(data){
    return http.post('api/Policy/assessmentdata',data);
}

///api/Policy/pageresult

export function getApiPageresult(data){
    return http.post('api/Policy/pageresult',data);
}

export function getApiPolicyPDetail(data){
    return http.post('api/Policy/getPDetail',data);
}

export function getApiPolicyDetail(data){
    return http.post('api/Policy/getDetail',data);
}

///api/Policy/PfindWithPager

export function getApiPfindWithPager(data){
    return http.post('api/Policy/PfindWithPager',data);
}

///api/Policy/getfindWithPagerList

export function getApiFindWithPagerList(data){
    return http.post('api/Policy/getfindWithPagerList',data);
}

///api/Policy/GetAcademicLevel

export function getApiGetAcademicLevel(data){
    return http.get('api/Policy/GetAcademicLevel',data);
}

///api/Policy/GetAllPartition

export function getApiGetAllPartition(data){
    return http.get('api/Policy/GetAllPartition',data);
}

///api/Policy/GetAllIndustry

export function getApiGetAllIndustry(data){
    return http.get('api/Policy/GetAllIndustry',data);
}

///api/Policy/GetAllChaPlate

export function getApiGetAllChaPlate(data){
    return http.get('api/Policy/GetAllChaPlate',data);
}

///api/Policy/getfindWithPager

export function getApiFindWithPager(data){
    return http.get('api/Policy/getfindWithPager',data);
}

///api/policy/GetAreaList

export function getApiGetAreaList(data){
    return http.get('api/Policy/GetAreaList',data);
}

///api/Policy/GetDeptList

export function getApiGetDeptList(data){
    return http.get('api/Policy/GetDeptList',data);
}


///api/Index/setDemand

export function getApiSetDemand(data){
    return http.post('api/Index/setDemand',data);
}

///api/Index/getResultsInfo

export function getApiResultInfo(data){
    return http.get('api/Index/getResultsInfo',data);
}

///api/Index/getResultsList

export function getApiResultList(data){
    return http.get('api/Index/getResultsList',data);
}

///api/Index/getServiceInfo /api/Mechanism/getMsInfo

export function getApiServiceInfo(data){
    return http.get('api/Mechanism/getMsInfo',data);
}

///api/Index/getPartyList

export function getApiPartyList(data){
    return http.post('api/Index/getPartyList',data);
}

///api/Index/getPartyInfo

export function getApiPartyInfo(data){
    return http.post('api/Index/getPartyInfo',data);
}

///api/Index/getEduTypeList

export function getApiEduTypeList(data){
    return http.post('api/Index/getEduTypeList',data);
}

///api/Index/getEduList


export function getApiEduList(data){
    return http.post('api/Index/getEduList',data);
}

///api/Index/getEduInfo

export function getApiEduInfo(data){
    return http.post('api/Index/getEduInfo',data);
}

///api/Index/getTribalType

export function getApiTribalType(data){
    return http.post('api/Index/getTribalType',data);
}

///api/Index/getTribalList

export function getApiTribalList(data){
    return http.post('api/Index/getTribalList',data);
}

///api/User/checkCompany

export function checkCompany(data){
    return http.post('api/User/checkCompany',data);
}

///api/User/setCompany

export function setCompany(data){
    return http.post('api/User/setCompany',data);
}

///api/Index/getZbannerList

export function getZbannerList(data){
    return http.post('api/Index/getZbannerList',data);
}






///api/Index/setSignInfo

export function getApisetSignInfo(data){
    return http.post('api/Index/setSignInfo',data);
}

///api/Index/setData

export function getApisetData(data){
    return http.post('api/Index/setData',data);
}

///api/Index/getSignInfo

export function getApigetSignInfo(data){
    return http.get('api/Index/getSignInfo',data);
}


///api/User/mobilecheck

export function getApiMobileCheck(data){
    return http.post('api/User/mobilecheck',data);
}

//api/Index/editSignInfo

export function getApieditSignInfo(data){
    return http.post('api/Index/editSignInfo',data);
}

///api/Index/getHomemap

export function getApiHomeMap(data){
    return http.post('api/Index/getHomemap',data);
}

///api/Index/getMapList

export function getApiMapList(data){
    return http.post('api/Index/getMapList',data);
}

//api/Index/getRenConfig

export function getRenConfig(data){
    return http.post('api/Index/getRenConfig',data);
}
